"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkNFQD3NML_js = require('./chunk-NFQD3NML.js');
var chunkIKADDSM6_js = require('./chunk-IKADDSM6.js');
var chunkXY5WXQCX_js = require('./chunk-XY5WXQCX.js');
var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var g = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var g__default = /*#__PURE__*/_interopDefaultLegacy(g);

var b=g.css`
  gap: var(--spacing-x-small);
  padding-bottom: calc(var(--spacing-large) + var(--spacing-small));

  ${chunkIKADDSM6_js.a} {
    bottom: 4px;
    font-size: var(--font-size-small);
    position: absolute;
    & > * {
      font-size: var(--font-size-small);
    }
  }

  ${chunkXY5WXQCX_js.a} > * {
    font-size: var(--font-size-small);
  } ;
`,F=g.css`
  flex-direction: row;
  gap: var(--spacing-regular);
`,$=g__default["default"].div`
  display: flex;
  gap: var(--spacing-small);
  flex-direction: column;
  position: relative;
  padding-bottom: ${({$compact:o})=>o?"0":"calc(var(--spacing-large) + var(--spacing-small))"};

  ${chunkIKADDSM6_js.a} {
    font-size: var(--font-size-regular);
    position: absolute;
    bottom: 8px;
    word-break: break-all;

    ${({$compact:o})=>o&&g.css`
        position: relative;
        bottom: 0;
      `}

    ${({$disabled:o})=>o&&g.css`
        color: var(--foreground-disabled);
      `}
  }

  ${chunkXY5WXQCX_js.a} {
    font-size: var(--font-size-regular);

    ${chunk2VCHSK65_js.d} {
      ${({$disabled:o})=>o&&g.css`
          color: var(--foreground-disabled) !important;
        `}
    }
  }

  ${({$size:o})=>o==="small"&&b}
  ${({$inline:o})=>o&&F}
`,t={FormField:$};var s=({children:o,size:n,inline:m,disabled:p,compact:d=!1,...c})=>{let{size:f}=chunkNFQD3NML_js.b();return jsxRuntime.jsx(t.FormField,{$inline:Boolean(m),$size:n||f,$disabled:p,$compact:d,...c,children:o})};s.displayName="FormField";var z=g__default["default"](s)``;

exports.a = z;
